module.exports = __webpack_public_path__ + "static/brand-69f4b575424f812f47860b6f06861583.svg";